import React from "react";

const CEOMessage = () => {
  return (
    <div className="container-xxl py-5 position-relative overflow-hidden">
      <div className="container">
        <div className="row g-0 align-items-center">
          {/* Left Block: Identity - Slides in from left */}
          <div className="col-lg-5 animate-slide-in-left">
            <div
              className="p-5 shadow-lg text-white position-relative overflow-hidden"
              style={{
                background: "linear-gradient(135deg, #0a1d37 0%, #050d1a 100%)",
                borderRadius: "40px 0 120px 0",
                minHeight: "480px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition: "transform 0.3s ease",
              }}
            >
              <div
                className="position-absolute start-0 top-0 h-100 bg-primary"
                style={{ width: "6px" }}
              ></div>

              <div className="animate-fade-up-delay-1">
                <span
                  className="text-primary fw-bold text-uppercase small mb-3 d-block"
                  style={{ letterSpacing: "4px" }}
                >
                  Founder's Perspective
                </span>
                <h1
                  className="display-4 fw-bold text-white mb-0"
                  style={{ letterSpacing: "-2px", lineHeight: "1.1" }}
                >
                  Leadership & <br />{" "}
                  <span style={{ color: "#86B817" }}>Integrity.</span>
                </h1>
              </div>

              <div className="mt-5 animate-fade-up-delay-2">
                <p
                  className="text-white-50 small text-uppercase fw-black mb-1"
                  style={{ letterSpacing: "1px" }}
                >
                  Organization
                </p>
                <h5
                  className="fw-normal text-white mb-0"
                  style={{ opacity: 0.9 }}
                >
                  All World Recruiting & <br /> Overseas Employment Agency
                </h5>
              </div>
            </div>
          </div>

          {/* Right Block: Content - Slides in from right and overlaps */}
          <div className="col-lg-7 animate-slide-in-right">
            <div
              className="bg-white shadow-lg p-5 ms-lg-n5 my-lg-5 position-relative hover-lift"
              style={{
                borderRadius: "0 80px 0 80px",
                border: "1px solid rgba(0,0,0,0.05)",
                zIndex: 2,
              }}
            >
              <div className="ps-lg-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="bg-light p-2 rounded-circle me-3">
                    <i className="fa fa-quote-left text-primary"></i>
                  </div>
                  <div className="flex-grow-1 border-bottom border-light"></div>
                </div>

                <h2 className="h1 fw-bold text-dark mb-4 animate-fade-up-delay-1">
                  A Shared Path to{" "}
                  <span className="text-primary">National Growth</span>
                </h2>

                <div
                  className="text-muted mb-5 animate-fade-up-delay-2"
                  style={{ lineHeight: "1.9", fontSize: "1.08rem" }}
                >
                  <p className="text-dark fw-bold mb-4">
                    "Being a Pakistani national working for the promotion of
                    foreign employment, I am proud to bridge our nation's
                    sincere talent with the global market."
                  </p>

                  <p className="mb-4">
                    Our success belongs to international employers who trust
                    Pakistani workers as efficient talent. It is our workforce
                    that has proven their professional honesty in demanding
                    situations.
                  </p>

                  <p className="mb-0">
                    Our mission is to enrich the national economy by meeting
                    global demand for quality manpower, ensuring excellence for
                    both employees and employers.
                  </p>
                </div>

                {/* Signature */}
                <div className="pt-4 border-top d-flex flex-column flex-md-row align-items-md-center justify-content-between animate-fade-up-delay-3">
                  <div>
                    <h4 className="mb-0 fw-bold text-dark">
                      M. Ashraf Khan Bungash
                    </h4>
                    <p className="text-primary mb-0 fw-bold small text-uppercase">
                      Proprietor | Est. 2012
                    </p>
                  </div>
                  <div className="mt-3 mt-md-0">
                    <span className="badge bg-light text-dark border p-2 px-3 rounded-pill fw-bold">
                      <i className="fa fa-check-circle text-primary me-2"></i>
                      Official Statement
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modern Professional CSS Animations */}
      <style>{`
        .ms-lg-n5 { margin-left: -5rem !important; }
        .fw-black { font-weight: 900; }

        .animate-slide-in-left {
          animation: slideInLeft 1s cubic-bezier(0.23, 1, 0.32, 1) both;
        }

        .animate-slide-in-right {
          animation: slideInRight 1s cubic-bezier(0.23, 1, 0.32, 1) both;
        }

        .animate-fade-up-delay-1 { animation: fadeUp 0.8s ease out 0.4s both; }
        .animate-fade-up-delay-2 { animation: fadeUp 0.8s ease out 0.6s both; }
        .animate-fade-up-delay-3 { animation: fadeUp 0.8s ease out 0.8s both; }

        .hover-lift {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-lift:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.12) !important;
        }

        @keyframes slideInLeft {
          0% { transform: translateX(-100px); opacity: 0; }
          100% { transform: translateX(0); opacity: 1; }
        }

        @keyframes slideInRight {
          0% { transform: translateX(100px); opacity: 0; }
          100% { transform: translateX(0); opacity: 1; }
        }

        @keyframes fadeUp {
          0% { transform: translateY(20px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }

        @media (max-width: 991.98px) {
          .ms-lg-n5 { margin-left: 0 !important; margin-top: -3rem !important; }
          .animate-slide-in-left, .animate-slide-in-right { animation: fadeUp 1s ease both; }
        }
      `}</style>
    </div>
  );
};

export default CEOMessage;
